/**
 * SxaAssessmentInputTile.js
 *
 * Copyright (c) 2018-2019 i-Solutions Global Ltd. All Rights Reserved.
 *
 * This software is the confidential and proprietary information of
 * i-Solutions Global Ltd. ("Confidential Information").  You shall
 * not disclose such Confidential Information and shall use it only in
 * accordance with the terms of the license agreement you entered into
 * with i-Solutions Global Ltd.
 *
 * I-SOLUTIONS GLOBAL LTD MAKES NO REPRESENTATIONS OR WARRANTIES ABOUT
 * THE SUITABILITY OF THE SOFTWARE, EITHER EXPRESS OR IMPLIED, INCLUDING BUT NOT
 * LIMITED TO THE IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A
 * PARTICULAR PURPOSE, OR NON-INFRINGEMENT. I-SOLUTIONS GLOBAL LTD SHALL NOT BE
 * LIABLE FOR ANY DAMAGES SUFFERED BY LICENSEE AS A RESULT OF USING, MODIFYING OR
 * DISTRIBUTING THIS SOFTWARE OR ITS DERIVATIVES.
 *
 * Version 1.0
 */

import React from 'react';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

// Sxa Components
import SxaProcessAreaSelectionTile from './SxaProcessAreaSelectionTile';
import SxaQuestionScoreInputTile from "./SxaQuestionScoreInputTile";
import SxaDimensionSelectionTile from "./SxaDimensionSelectionTile";
import SxaAssessmentNavTile from "./SxaAssessmentNavTile";


class SxaAssessmentInputTile extends React.Component {
    constructor(props) {
        super(props);
        // Assign current Q ref to state for refresh
        this.state = {
            ass: props.ass,
            currq: props.ass.currentQuestion
        };
    }

    componentDidMount() {
        //console.log("AssessmentInput.componentDidMount(): re-set PA,D selection state");

        // Conditional refresh of PA,D selection state
        // (e.g. for portrait to landscape switch)
        var q = this.state.currq;
        if (q) {
            if (this.pasel) {
                this.pasel.updateSelectionState(q);
            }
            if (this.dsel) {
                this.dsel.updateSelectionState(q);
            }
        }
    }

    // Callback function used by children to signal Q change (e.g. nav back or next, PA or D select)
    handleQChange = (q) => {
        // Check for Q already set
        var currQ = this.state.currq;
        if (currQ.oid === q.oid) {
            //console.log("A-Input.handleQChange(): current Question was NOT changed; Q = " + q.oid);

            // Signal the Q change up - in case stale
            this.props.signalQChange(q);

            // Update nav buttons (turns off Next for lastQ when no longer defaulted)
            this.nav.changeQuestion(q);

            // N.B. ALSO signal score change - to handle case where Next is clicked and default score is taken
            // FIXME - make this more specific? only on Next (not Back), only if score was defaulted? - need more K for that
            console.log("A-Input: triggering score change for same-Q change signal (handles Next for defaulted)");
            this.handleScoreChange();

            return;
        }

        //console.log("A-Input: current Question was changed; new Q = " + q.oid);

        // Trigger re-render
        this.setState(state => ({currq: q}));

        // Re-bind the Q-Input tile
        this.qin.changeQuestion(q);

        // Update D selection
        this.dsel.updateSelectionState(q);

        // Update PA selection
        this.pasel.updateSelectionState(q);

        // Update nav buttons
        this.nav.changeQuestion(q);

        // Signal the Q change up (so client-side A can be updated)
        // Or handle lower down (depends on A bindings - e.g. PA/D selection tiles)
        this.props.signalQChange(q);

        // N.B. ALSO signal score change - to handle case where Next is clicked and default score is taken
        // FIXME - make this more specific? only on Next (not Back), only if score was defaulted? - need more K for that
        console.log("A-Input: triggering score change for Q change (handles Next for defaulted)");
        this.handleScoreChange();
    }

    // Callback function used by child to signal Q-score change
    handleScoreChange = () => {
        //console.log("Assessment_Input.handleScoreChange()");

        // Signal the Assessment_Root container - callback function
        this.props.signalScoreChange();
    };

    handleAChange = (a) => {
        //console.log("AssessmentInput: current A was changed");

        // Reset A ref
        this.setState(state => ({ass: a}));

        // Update curr Q
        this.handleQChange(a.currentQuestion);
    }

    render() {
        return (
            <React.Fragment>
                {this.state.ass ? (
                    <div>
                        <div style={{ background: 'white',
                            padding: 0,
                            overflowX: 'hidden',
                            overflowY: 'hidden'
                        }}>
                        <Grid container spacing={0} style={{padding: 0}}
                              direction="row" justify="center" alignItems="stretch">
                            <Grid item xs={3} sm={3} lg={3} xl={3}>
                                <SxaProcessAreaSelectionTile ass={this.state.ass}
                                                             ref={(pasel) => { this.pasel = pasel; }}
                                                             handleQChange={this.handleQChange}
                                    />
                            </Grid>
                            <Grid item xs={9} sm={9} lg={9} xl={9}>
                                <Grid container spacing={8} style={{padding: 0}}
                                      direction="row" justify="flex-start" alignItems="stretch">
                                    <Grid item xs={12} sm={12} lg={12} xl={12}>
                                        <SxaDimensionSelectionTile ass={this.state.ass}
                                                                   ref={(dsel) => { this.dsel = dsel; }}
                                                                   handleQChange={this.handleQChange}
                                        />
                                        <Typography align="right" color="inherit"
                                                    style={{ fontSize: 15, marginTop: '1.0em', paddingRight: 12 }}>
                                            {this.state.currq.masterOrdinal} of {this.state.currq.totalQCount}
                                        </Typography>
                                    </Grid>
                                    <Grid item xs={12} sm={12} lg={12} xl={12}>
                                        <SxaQuestionScoreInputTile q={this.state.currq}
                                                                   ref={(qin) => { this.qin = qin; }}
                                                                   handleScoreChange={this.handleScoreChange}
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                        </div>
                        <SxaAssessmentNavTile q={this.state.currq}
                                              ref={(nav) => { this.nav = nav; }}
                                              handleQChange={this.handleQChange}
                        />
                    </div>
                ) : "No Assessment found"}
            </React.Fragment>
        )
    }
}

export default SxaAssessmentInputTile;